import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Section from "./Section";

const showcaseImages = [
  "/fr-1.png",
  "/anime-1.png",
  "/boobs-1.png",
  "/fr-2.png",
  "/anime-2.png",
  "/boobs-2.png",
  "/fr-3.png",
  "/anime-3.png",
  "/boobs-3.png",
  "/fr-4.png",
  "/anime-4.png",
  "/boobs-4.png",
];

const useStyles = makeStyles({
  "@keyframes scrollX": {
    "0%": { transform: "translate3d(0, 0, 0)" },
    "100%": { transform: "translate3d(-50%, 0, 0)" },
  },
  marquee: {
    display: "flex",
    width: "max-content",
    gap: "16px",
    animation: "$scrollX 60s linear infinite",
    "&:hover": {
      animationPlayState: "paused",
    },
  },
});

function ImageShowcase() {
  const classes = useStyles();
  const loop = [...showcaseImages, ...showcaseImages];

  return (
    <Section bgColor="default" size="auto">
      <div
        aria-hidden="true"
        className="relative overflow-hidden py-10"
        style={{
          maskImage:
            "linear-gradient(90deg, transparent 0, #000 8%, #000 92%, transparent 100%)",
          WebkitMaskImage:
            "linear-gradient(90deg, transparent 0, #000 8%, #000 92%, transparent 100%)",
        }}
      >
        <div className={classes.marquee}>
          {loop.map((src, i) => (
            <div
              key={i}
              className="relative shrink-0 overflow-hidden rounded-2xl border border-white/10 bg-white/5 shadow-xl"
              style={{ width: 200, aspectRatio: "3 / 4" }}
            >
              <img
                src={src}
                alt=""
                loading="lazy"
                className="h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}

export default ImageShowcase;
